import React from 'react';

const CancellationAndRefund = () => {
  return (
    <div className="policy-page-container">
      {/* Breadcrumb Section */}
      <div className="policy-breadcrumb">
        <div className="breadcrumb-content">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Cancellation and Refund Policy
              </li>
            </ol>
          </nav>
          <h1 className="breadcrumb-title">Cancellation and Refund Policy</h1>
        </div>
      </div>

      <div className="policy-wrapper">
        <div className="policy-content">
          {/* Header Section */}
          <header className="policy-header">
            <p className="policy-update-date"><strong>Updated effective from 1st April, 2022</strong></p>
            <div className="policy-notice-banner">
              <h2>Thank you for choosing to make a payment through our platform.</h2>
              <p>
                Please read the following policy carefully before proceeding with any transactions.
              </p>
            </div>
          </header>

          {/* Policy Sections */}
          <div className="policy-sections">
            <section className="policy-section">
              <h2>1. Cancellations</h2>
              <p>
                Once a payment has been successfully initiated or processed, it cannot be canceled automatically through the system.
              </p>
              <p>
                If you made a payment in error or need to cancel a transaction, please contact our support team immediately 
                at <strong>sales@Click4pay.com</strong> with full details of the transaction (order ID, date, amount, and reason for cancellation).
              </p>
              <p>
                Cancellation requests will be reviewed on a case-by-case basis and may be accepted only if the transaction 
                has not yet been processed by our payment gateway or partner bank.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Refunds</h2>
              <p>Refunds are issued only in cases where:</p>
              <ul>
                <li>The transaction was unsuccessful, but the amount was debited from your account.</li>
                <li>The transaction was processed by mistake due to technical issues or system errors.</li>
                <li>The payment was made for a service/product that could not be delivered or fulfilled.</li>
              </ul>
              <p>
                Once approved, refunds will be processed within <strong>7–10 business days</strong>, depending on your bank or payment provider.
              </p>
              <p>
                Refunds will be credited to the <strong>original mode of payment</strong> only.
              </p>
              <p>
                We are not responsible for any delays caused by the bank or payment gateway.
              </p>
            </section>

            <section className="policy-section">
              <h2>3. No Refund Conditions</h2>
              <p>Refunds will not be provided in the following cases:</p>
              <ul>
                <li>If the service/product was delivered as promised.</li>
                <li>If the payment was made for a non-refundable item or plan.</li>
                <li>If the user fails to provide required information or cancels after confirmation.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Disputes</h2>
              <p>
                In case of disputes regarding any transaction, please contact our support within <strong>48 hours</strong> of the payment. 
                We will investigate and assist you promptly.
              </p>
            </section>

            <section className="policy-section">
              <h2>5. Contact Us</h2>
              <p>For any questions about cancellations or refunds, please reach out to us at:</p>
              <div className="contact-info">
                <p>📧 <strong>sales@Click4pay.com</strong></p>
                {/* <p>📞 <strong>[Your customer care number]</strong></p> */}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationAndRefund;